import router from '@/router/'

const defaultConfig = {
    requestSuccess(opt) { // 请求发送前
        // 设置token
        if (!opt.data) {
            opt.data = {}
        }
        let userinfo = Vue.$Config.userinfo || null
        opt.headers.Authorization = userinfo.token
        return opt
    },
    requestError(err) { // 请求发送前出错
        return Promise.reject(err)
    },
    responseSuccess(response) { // http响应正常
        switch (response.data.code) { // 内部code
            case 200: // 正常
                return Promise.resolve(response.data.data)
            case '1002':
            case '1003': //token失效
            case 201: // 登录失效
                router.push({name: 'login'})
                localStorage.removeItem('userinfo')
                break
            default:
                return Promise.reject(response.data)
        }
    },
    async responseError(err) { // http响应出错
        if (err.__CANCEL__) { // 请求被取消
        } else {
            return Promise.reject(err.response || err.request)
        }
    },
    validateStatus: function (status) {
        return status >= 200 && status < 300
    }
}

export default (axios, opt) => {
    const config = Object.assign({}, defaultConfig, opt)
    axios.interceptors.request.use(config.requestSuccess, config.requestError)
    axios.interceptors.response.use(config.responseSuccess, config.responseError)
    return axios
}
